






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { firebaseApp, firebaseDB } from '@/firebase';
import ChangeOrderStatus from './AndroidCallback/ChangeOrderStatus.vue'
// import AutoPrint from './AutoPrint.vue';

@Component({
  components: {
    ChangeOrderStatus,
    // AutoPrint
  }
})
export default class Header extends Vue {
  @Prop(Boolean) isMobile!: boolean;
  $swal: any;

  mounted() {
    // Check BO version to clear webview cache
    if (window && typeof (window as any).android !== 'undefined') {
      const doc = firebaseDB.collection('Version').doc('BO');
      doc.onSnapshot((snapshot) => {
        if (snapshot.exists && snapshot.get('version') > Number(process.env.VUE_APP_VERSION)) {
          this.$swal('There was an update, please empty the webview cache.', {
            buttons: true,
          }).then(value => {
            if (value) {
              (window as any).android.clearAppCache();
            }
          });
        }
      })
    }
  }

  get userType() {
    return this.$store.state.currentUser
      ? this.$store.state.currentUser.Type
      : '';
  }

  get isEDC() {
    return this.$store.state.isEDC;
  }

  public handleToggle(value: string) {
    this.$emit('update-toggle', value);
  }

  public pushPage(route: string) {
    this.$router.push(route);
  }

  logOut() {
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.unsetFirebaseToken();
    }
    if (window && typeof (window as any).webkit !== 'undefined') {
      (window as any).webkit.messageHandlers.sendUserInfo.postMessage({
        userID: '',
        isSign: false
      });
    }
    this.$store.commit('SET_PAGING_PAGE_STORE', 1);
    this.$store.dispatch('LOAD_CURRENT_USER', { uid: '' });
    this.$store.dispatch('LOAD_USER_PRIVILEGES', '');
    firebaseApp
      .auth()
      .signOut()
      .then(data => {
        sessionStorage.clear();
        location.href = '/login';
      });
  }
}
